// extracted by mini-css-extract-plugin
export default {"context-menu__options":"_5D1ixj4M"};